export const getPriceCode = () => {
  const priceCode = localStorage.getItem('price_code'); // Retrieve the price_code from localStorage. The price_code is used to fetch related records from the API
  return priceCode;
};

export { getPriceCode as default };
